import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
